export default class BaseService {
    /**
     * @returns {ZeroContextServices}
     */
    getServices() {} // Only defined for type checking. See ZeroContext.js for implementation.
}